import { createAsyncThunk } from "@reduxjs/toolkit";
import { Authentication, LoginRequest } from "../../services/authentication";
import { UsersService } from "../../services/users";
export const Login = createAsyncThunk(
  "user/login",
  async (resquest: LoginRequest) => await Authentication.login(resquest)
);

export const UserThunk = createAsyncThunk("user/0", async () => await (await UsersService.getCurrentUser()).parsedBody);
